export const TAG_SIZES = {
  SMALL: "small",
  LARGE: "large",
};

export const getTagData = ({ size }) => {
  let wrapperClassName = "",
    labelVariant = "body5";
  switch (size) {
    case TAG_SIZES.SMALL:
      wrapperClassName = "label-tag-wrapper-small";
      labelVariant = "body6";
      break;

    default:
      break;
  }
  return {
    wrapperClassName,
    labelVariant,
  };
};
